import React, { HTMLAttributes } from 'react';
import { classNames } from '../dom';
import './LoadingLogo.scss';

export interface LoadingLogoProps extends HTMLAttributes<HTMLElement> {
  /* Custom class name for the loading logo */
  className?: string;
  /* Whether the loading logo should be the small size  */
  isSmall?: boolean;
  /* Display a darker blue */
  dark?: boolean;
  /* Display PF colors post-merger */
  pf?: boolean;
}

const LoadingLogo = (props: LoadingLogoProps) => {
  const { className, dark, isSmall, pf } = props;

  const loadingLogoClassNames = classNames(
    'ps-loading-logo',
    className,
    isSmall ? 'ps-loading-logo--small' : '',
    dark ? 'dark' : '',
    pf ? 'pf' : ''
  );

  const fourthClassName = classNames('ps-loading-logo__dot', pf ? 'orange' : '');

  const ninethClassName = classNames('ps-loading-logo__dot', pf ? 'purple' : '');

  const eleventhClassName = classNames('ps-loading-logo__dot', pf ? 'teal' : '');

  const fourteenthClassName = classNames('ps-loading-logo__dot', pf ? 'blue' : '');

  return (
    <div className={loadingLogoClassNames}>
      <div className="ps-loading-logo__dots">
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
        <div className={fourthClassName} />
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
        <div className={ninethClassName} />
        <div className="ps-loading-logo__dot" />
        <div className={eleventhClassName} />
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
        <div className={fourteenthClassName} />
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
        <div className="ps-loading-logo__dot" />
      </div>
    </div>
  );
};
export { LoadingLogo };
